import type { AvatarCardProps } from "@/ui/core/AvatarCard";
import AvatarCard from "@/ui/core/AvatarCard";
import { FlatList } from "@/ui/layout";

interface ChannelParticipantListProps extends ViewWithTestID {
  participants?: AvatarCardProps[];
}

const ChannelParticipantList = ({
  participants,
  testID,
}: ChannelParticipantListProps) => {
  return (
    <FlatList
      data={participants}
      renderItem={({ item }) => {
        return (
          <AvatarCard
            subtitle={item.subtitle}
            userId={item.userId}
            userName={item.userName}
            userType={item.userType}
          />
        );
      }}
      testID={testID}
    />
  );
};

export default ChannelParticipantList;
